import { render } from "./ViewProduct.vue?vue&type=template&id=26565ad2"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"

import "./ViewProduct.vue?vue&type=style&index=0&id=26565ad2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__